import { computed, Injectable, signal } from '@angular/core';
import { getFromStorage, saveToStorage } from '../../../helpers/storageUtils';


export interface OnerousSelection {
    isFinanced: boolean;
    hasAccessories: boolean;
    isCeroKM: boolean;
    key: string;
}

const STORAGE_KEY = 'OnerousSelectionState';

@Injectable({
    providedIn: 'root',
})
export class OnerousStateService {
    private selectionSignal = signal<OnerousSelection>(this.loadInitialState());

    readonly selection = this.selectionSignal.asReadonly();
    readonly key = computed(() => this.selection().key);

    saveSelection(financed: boolean, accessories: boolean, ceroKm: boolean): void {
        const key = `${+financed}${+accessories}${+ceroKm}`;
        const newState: OnerousSelection = {
            isFinanced: financed,
            hasAccessories: accessories,
            isCeroKM: ceroKm,
            key,
        };

        this.selectionSignal.set(newState);
        saveToStorage(STORAGE_KEY, newState, 'session');
    }

    private loadInitialState(): OnerousSelection {
        const saved = getFromStorage<OnerousSelection>(STORAGE_KEY, 'session');
        if (saved) return saved;

        return {
            isFinanced: false,
            hasAccessories: false,
            isCeroKM: false,
            key: '000',
        };
    }
}